/*global _ */
import {min, max, floor, ceil, round} from './config'

export default {
    data() {
        return {
            initValue: {start: 0, end: 0},
            duration: 0,
        }
    },
    computed: {

    },
    watch: {

    },

    created() {
        const duration = this.data?.meta?.duration || 0
        const end = this.duration = min([duration, floor(duration, 1)])
        const start = 0
        this.initValue = {start, end}
        if (!this.innerValue) {
            this.innerValue = this.initValue
        }
    },
    mounted() {

    },
    methods: {
        percent2Time(p, isNearEnd) {

        },
        percent2Pixel(p, isNearEnd) {

        },
        time2Percent(time, isNearEnd) {

        },
        time2Pixel(time, isNearEnd) {

        },
        pixel2Time(px, isNearEnd) {

        },
        pixel2Percent(px, isNearEnd) {
            const width = this.els.frames.clientWidth
            return (px / width * 100) + '%'
        },
        calc() {
            const startPos = this.els.selected?.offsetLeft - this.els.start?.clientWidth
            const endPos = startPos + this.els.selected?.clientWidth
            const data = {...this.initValue}
            const scaleWidth = this.els.frames.clientWidth - (this.els.start.clientWidth + this.els.end.clientWidth)
            const pixelScaleFactor = this.duration / scaleWidth

            if (!_.isNil(endPos)) {
                data.end = min([this.duration, ceil(endPos * pixelScaleFactor,  1)])
            }
            if (!_.isNil(startPos)) {
                data.start = max([0, floor(startPos * pixelScaleFactor, 1)])
            }

            this.innerValue = {...data}
            return data
        },

        dCalc(w) {
            const width = this.els.frames.clientWidth
            const duration = this.duration || 0
            const {start: startTime = 0, end: endTime = duration} = this.innerValue || {}
            const startOffset = this.els.start.clientWidth
            const endOffset = this.els.start.clientWidth
            const scaleWidth = width - (startOffset + endOffset)
            let start = 0
            let end = width
            let scale = 1
            if (duration) {
                scale = scaleWidth / duration
                start = startTime * scale
                end = endTime * scale + endOffset * 2
            }
            return {start, end}
        },
    }
}
